module.exports = __webpack_public_path__ + "media/images/lla-logo--star-white-37c8621ada44e161cc55781a99b90d36.svg";